import { createActions, createReducer } from 'reduxsauce';
import immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  getEventualInsuranceDetails: ['courseId', 'quoteParams'],
  getEventualInsuranceDetailsDone: ['insurance'],
  getEventualInsuranceDetailsError: ['errorMessage'],
  resetEventualWeather: [],
  getInsuranceQuote: ['reservationId', 'accessToken'],
  getInsuranceQuoteDone: ['quote', 'creditCard'],
  getInsuranceQuoteError: ['errorMessage', 'timeout'],
  setInsuranceCreditCard: ['creditCard'],
  purchaseEventualInsurance: ['reservationId', 'params'],
  purchaseEventualInsuranceDone: ['status'],
  purchaseEventualInsuranceError: ['errorMessage'],
});

export const EventualWeatherTypes = Types;
export default Creators;

const INITIAL_STATE = immutable.from({
  insurance: {},
  insuranceQuote: {},
  insuranceCreditCard: null,
  insuranceStatus: '',
  isFetchingInsuranceDetails: false,
  isFetchingInsuranceDetailsDone: false,
  fetchingInsuranceDetailsError: '',
  isGettingInsuranceQuote: false,
  isGettingInsuranceQuoteTimeout: false,
  isGettingInsuranceQuoteDone: false,
  isPurchasingInsurance: false,
  isPurchasingInsuranceDone: false,
  purchasingInsuranceError: false,
  gettingInsuranceQuoteError: '',
});

const resetEventualWeather = () => INITIAL_STATE;

const setInsuranceCreditCard = (state, { creditCard }) => state.merge({
  insuranceCreditCard: creditCard,
});

const getEventualInsuranceDetails = (state) => state.merge({
  isFetchingInsuranceDetails: true,
  isFetchingInsuranceDetailsDone: false,
  fetchingInsuranceDetailsError: '',
});

const getEventualInsuranceDetailsDone = (state, { insurance }) => state.merge({
  insurance,
  isFetchingInsuranceDetails: false,
  isFetchingInsuranceDetailsDone: true,
  fetchingInsuranceDetailsError: '',
});

const getEventualInsuranceDetailsError = (state, { errorMessage }) => state.merge({
  isFetchingInsuranceDetails: false,
  isFetchingInsuranceDetailsDone: true,
  fetchingInsuranceDetailsError: errorMessage,
});

const getInsuranceQuote = (state) => state.merge({
  isGettingInsuranceQuote: true,
  isGettingInsuranceQuoteDone: false,
  gettingInsuranceQuoteError: '',
});

const getInsuranceQuoteDone = (state, { quote }) => state.merge({
  insuranceQuote: quote,
  isGettingInsuranceQuote: false,
  isGettingInsuranceQuoteDone: true,
  gettingInsuranceQuoteError: '',
});

const getInsuranceQuoteError = (state, { errorMessage, timeout }) => state.merge({
  isGettingInsuranceQuote: false,
  isGettingInsuranceQuoteTimeout: timeout,
  isGettingInsuranceQuoteDone: true,
  gettingInsuranceQuoteError: errorMessage,
});

const purchaseEventualInsurance = (state) => state.merge({
  isPurchasingInsurance: true,
  isPurchasingInsuranceDone: false,
  purchasingInsuranceError: '',
});

const purchaseEventualInsuranceDone = (state, { status }) => state.merge({
  insuranceStatus: status,
  isPurchasingInsurance: false,
  isPurchasingInsuranceDone: true,
  purchasingInsuranceError: '',
});

const purchaseEventualInsuranceError = (state, { errorMessage }) => state.merge({
  isPurchasingInsurance: false,
  isPurchasingInsuranceDone: true,
  purchasingInsuranceError: errorMessage,
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_EVENTUAL_INSURANCE_DETAILS]: getEventualInsuranceDetails,
  [Types.GET_EVENTUAL_INSURANCE_DETAILS_DONE]: getEventualInsuranceDetailsDone,
  [Types.GET_EVENTUAL_INSURANCE_DETAILS_ERROR]: getEventualInsuranceDetailsError,
  [Types.RESET_EVENTUAL_WEATHER]: resetEventualWeather,
  [Types.GET_INSURANCE_QUOTE]: getInsuranceQuote,
  [Types.GET_INSURANCE_QUOTE_DONE]: getInsuranceQuoteDone,
  [Types.GET_INSURANCE_QUOTE_ERROR]: getInsuranceQuoteError,
  [Types.SET_INSURANCE_CREDIT_CARD]: setInsuranceCreditCard,
  [Types.PURCHASE_EVENTUAL_INSURANCE]: purchaseEventualInsurance,
  [Types.PURCHASE_EVENTUAL_INSURANCE_DONE]: purchaseEventualInsuranceDone,
  [Types.PURCHASE_EVENTUAL_INSURANCE_ERROR]: purchaseEventualInsuranceError,
});
